var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIdCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2608 35.9131H48.4782",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2608 29.3914H48.4782",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2608 22.8696H40.8695",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1304 28.3043C21.8318 28.3043 24.0217 26.1144 24.0217 23.413C24.0217 20.7116 21.8318 18.5217 19.1304 18.5217C16.429 18.5217 14.2391 20.7116 14.2391 23.413C14.2391 26.1144 16.429 28.3043 19.1304 28.3043Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.913 38.0869C27.7727 33.6152 23.7453 30.4858 19.1304 30.4858C14.5155 30.4858 10.4881 33.6152 9.34778 38.0869H28.913Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3043 46.7826C46.3043 44.3814 44.3578 42.4348 41.9565 42.4348C39.5553 42.4348 37.6087 44.3814 37.6087 46.7826V47.8696C37.6087 48.4699 37.122 48.9565 36.5217 48.9565H22.3913C21.791 48.9565 21.3043 48.4699 21.3043 47.8696V46.7826C21.3043 44.3814 19.3578 42.4348 16.9565 42.4348C14.5553 42.4348 12.6087 44.3814 12.6087 46.7826V47.8696C12.6087 48.4699 12.122 48.9565 11.5217 48.9565H7.17391C5.97329 48.9565 5 47.9832 5 46.7826V14.1739C5 12.9733 5.97329 12 7.17391 12H52.8261C54.0267 12 55 12.9733 55 14.1739V46.7826C55 47.9832 54.0267 48.9565 52.8261 48.9565H47.3913C46.791 48.9565 46.3043 48.4699 46.3043 47.8696V46.7826Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIdCard);
export default __webpack_public_path__ + "static/media/icon-id-card.bd8275d5.svg";
export { ForwardRef as ReactComponent };